import { Metadata } from '../../types'

type DataAssetsProps = {
  metaData: Metadata | {}
}

const metaDataMap = {
  total_columns: {
    label: 'Columns',
    color: 'rgb(155, 141, 199)', // purple
  },
  total_tables: {
    label: 'Table',
    color: 'rgb(107, 155, 209)', // blue
  },
  total_schemas: {
    label: 'Schema',
    color: 'rgb(201, 142, 154)', // pink
  },
  total_databases: {
    label: 'Database',
    color: 'rgb(124, 176, 154)', // green
  },
}

const DataAssets = ({ metaData = {} }: DataAssetsProps) => {
  const data = Object.entries(metaData).map(([key, value]) => {
    const meta = metaDataMap[key as keyof typeof metaDataMap]
    return {
      label: meta.label,
      value,
      color: meta.color,
    }
  })

  const total = data.reduce((sum, item) => sum + item.value, 0)

  // Compute strokeDasharray values for SVG circles
  let offset = 0
  const circles = data.map((item) => {
    const dashArray = (item.value / total) * 263.89378290154264 // total circumference
    const circle = {
      color: item.color,
      dashArray,
      dashOffset: -offset,
    }
    offset += dashArray
    return circle
  })

  return (
    <div className='flex h-[144px] w-fit flex-col justify-start rounded-lg border border-gray-200 bg-gray-50 p-2 pl-4 pr-4'>
      <h3 className='mb-0 text-left text-[14px] font-medium text-[#111827]'>Total Data Assets</h3>
      <div className='mb-[8px] mt-[2px] flex items-center gap-4 pb-[0px] pt-[0px]'>
        {/* Donut chart */}
        <div className='flex flex-col items-center justify-center'>
          <div className='relative h-20 w-20'>
            <svg className='h-full w-full -rotate-90 transform' viewBox='0 0 100 100'>
              {circles.map((c, idx) => (
                <circle
                  key={idx}
                  cx='50'
                  cy='50'
                  r='42'
                  fill='none'
                  stroke={c.color}
                  strokeWidth='8'
                  strokeDasharray={`${c.dashArray} 263.89378290154264`}
                  strokeDashoffset={Number(c.dashOffset) || 0}
                  className='transition-all duration-500'
                />
              ))}
            </svg>
            <div className='absolute inset-0 flex items-center justify-center'>
              <span className='text-[18px] font-bold text-gray-900'>{total}</span>
            </div>
          </div>
        </div>

        {/* Legend */}
        <div className='flex flex-col gap-1 text-[12px]'>
          {data.map((item, idx) => (
            <div
              key={idx}
              className='flex items-center gap-1'
              data-testid={`quality-${item.label.toLowerCase()}-count`}
            >
              <div className='flex min-w-[70px] items-center gap-2'>
                <div className='h-2 w-2 rounded-full' style={{ backgroundColor: item.color }}></div>
                <span className='text-xs text-gray-600'>{item.label}</span>
              </div>
              <span className='min-w-[1.5ch] text-right text-xs font-semibold text-gray-900'>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DataAssets
